function pdfSlider() {
  $('.pdf-slider__pages').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    variableWidth: true
  });
}

$(document).ready(function () {
  pdfSlider();
});